import { css } from '@emotion/css';
import heartbeat from '@volumental/assets/icons/heartbeat.svg';
import { Text } from '@volumental/common';
import React, { useEffect } from 'react';
import { Popup } from './popup';

const content = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  justify-self: center;
  align-self: center;
  margin: 0 24px 24px 24px;
`;

const heartbeatTime = 2000;

interface PopupProps {
  close: () => void;
  show: boolean;
  messageText: string;
  desciption?: string;
}

export function ThankYouPopup({
  close,
  show,
  messageText,
  desciption,
}: PopupProps): React.JSX.Element {
  useEffect(() => {
    if (show) {
      setTimeout(close, heartbeatTime);
    }
  }, [show, close]);
  return (
    <Popup show={show} fixAspect>
      <div className={content}>
        <img src={heartbeat} alt={messageText} />
        <Text style={{ fontSize: '21px', fontWeight: 'bold' }}>
          {messageText}
        </Text>
        <Text>{desciption}</Text>
      </div>
    </Popup>
  );
}
